export default {
      id: "video-event_swerve-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "img/icons.svg#video-event_swerve",
      toString: function () {
        return this.url;
      }
    }